export default "__VITE_ASSET__CekELAiu__"